import {useTranslation} from 'react-i18next';
import {ReactComponent as DocumentIcon} from "../../../assets/icons/document.svg";
import {AttachmentPreviewItem, DISPLAY_ITEM_TYPE} from '../../../contexts/SelectedFilesContext';
import {
    AttachmentOuterWrapper,
    CollectionsList,
    FileExtension,
    FileIconWrapper,
    FileInfoContainer,
    FileName,
    FileTextInfo,
    RemoveButton
} from "./FileAttachmentList.styled";


interface FileAttachmentListProps {
    items: AttachmentPreviewItem[];
    onRemove: (item: AttachmentPreviewItem) => void;
}

const FileAttachmentList = ({
    items,
    onRemove
}: FileAttachmentListProps) => {
    const {t} = useTranslation();

    if (items.length === 0) {
        return null;
    }

    const renderItemName = (item: AttachmentPreviewItem) => {
        switch (item.type) {
            case DISPLAY_ITEM_TYPE.LOCAL_FILES:
                return t('attachFiles.localFiles');
            case DISPLAY_ITEM_TYPE.SOURCE_DOCUMENTS:
                return item.name;
            case DISPLAY_ITEM_TYPE.SOURCE_COLLECTION:
                return item.name;
            case DISPLAY_ITEM_TYPE.SOURCE_COLLECTIONS:
                return t('attachFiles.collections');
            default:
                return '';
        }
    };

    const renderItemType = (item: AttachmentPreviewItem) => {
        switch (item.type) {
            case DISPLAY_ITEM_TYPE.LOCAL_FILES:
                return t('attachFiles.filesCount', {count: item.count ?? 0});
            case DISPLAY_ITEM_TYPE.SOURCE_DOCUMENTS:
                return t('attachFiles.filesCount', {count: item.count ?? 0});
            case DISPLAY_ITEM_TYPE.SOURCE_COLLECTION:
                return t('attachFiles.collection');
            case DISPLAY_ITEM_TYPE.SOURCE_COLLECTIONS:
                return (
                    <CollectionsList>
                        {(item.data ?? []).map((item: AttachmentPreviewItem) => (
                            <FileExtension key={item.sourceId}>
                                {item.name} - {t('attachFiles.filesCount', { count: item.count ?? 0 })}
                            </FileExtension>
                        ))}
                    </CollectionsList>
                );
            default:
                return '';
        }
    };

    return (
        <AttachmentOuterWrapper>
            {items.map((item, index) => (
                <FileInfoContainer key={`${item.type}-${item.sourceId ?? item.name}-${index}`}>
                    <FileIconWrapper>
                        <DocumentIcon/>
                    </FileIconWrapper>

                    <FileTextInfo>
                        <FileName>
                            {renderItemName(item)}
                        </FileName>
                        <FileExtension>
                            {renderItemType(item)}
                        </FileExtension>
                    </FileTextInfo>

                    <RemoveButton onClick={() => onRemove(item)}/>
                </FileInfoContainer>
            ))}
        </AttachmentOuterWrapper>
    );
};

export default FileAttachmentList;